import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import https from "https";
import axios from "axios";
import log from "../utils/log";
import metaData from "../data/metaData";
import c from "../utils/common";

//
import useAuthStore from "../states/useAuth";
import useRequestStore from "../states/useRequest";
import useCompanyStore from "../states/useCompany";

const useCompany = () => {
  const { auth, user, updateUser } = useAuthStore();
  const { company, brand, updateCompany, updateBrand } = useCompanyStore();

  const getHomePageData = async () => {
    const response = await axios.get(metaData.serverURL + "merchantUser/portalHomePage", {
      headers: { Authorization: auth.jwt },
      httpsAgent: new https.Agent({ keepAlive: true, keepAliveMsecs: 60000 }),
    });

    log.debug(response.data);
    updateUser("whole", response.data.user);
    updateCompany("whole", response.data.company);
    updateBrand("whole", response.data.brand);

    return response.data; // Return the updated data
  };

  return { getHomePageData };
};

export default useCompany;
